var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import i18next from 'i18next';
import ICU from 'i18next-icu';
export const defaultNamespace = 'translation';
const defaultBackend = {
    type: 'backend',
    read(_lang, _namespace, callback) {
        return __awaiter(this, void 0, void 0, function* () {
            return callback(null, {});
        });
    },
};
export function createI18n(initialStore = {}, translationsBackend = defaultBackend, namespaces = []) {
    const i18n = i18next.createInstance();
    i18n.use(ICU);
    i18n.use(translationsBackend);
    i18n.init({
        nsSeparator: false,
        keySeparator: false,
        fallbackLng: false,
        ns: namespaces,
        defaultNS: defaultNamespace,
    });
    i18n.store.data = initialStore;
    i18n.isInitialized = true;
    return i18n;
}
//# sourceMappingURL=createI18n.js.map